import { GrowthBook } from '@growthbook/growthbook-react'

export enum FeatureKeys {
  SHARE_COUPON = 'share-coupon',
  CHECKOUT_V2 = 'checkout-v2',
  PRODUCT_CARD_V2 = 'product-card-v2',
}

export interface AppFeatures {
  [FeatureKeys.SHARE_COUPON]: boolean
  [FeatureKeys.CHECKOUT_V2]: boolean
  [FeatureKeys.PRODUCT_CARD_V2]: boolean
}

const growhthBook = new GrowthBook<AppFeatures>({
  apiHost: process.env.REACT_APP_GROWTHBOOK_API_HOST,
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  enableDevMode: process.env.REACT_APP_GROWTHBOOK_DEV_MODE === 'true',
})

export default growhthBook
